export default {
	"coupon.TheCouponHasExpiredAndTheCampaignIsInvalid": "优惠券已失效，活动无效"
}